<template>
  <ResponseContainer>
    <h2>Thanks for submitting your RSVP!</h2>
    <img src="@/assets/tick.svg" class="w-20 mx-auto my-4">
    <p class="mb-4">See all wedding details on the homepage.</p>
    <button @click="goToNext()">To homepage →</button>
  </ResponseContainer>
</template>

<script>
import ResponseContainer from '@/pages/ResponseContainer'
import Group from '@/models/group'

export default {
  name: 'ResponseSuccessPage',
  components: {
    ResponseContainer,
  },
  data() {
    return {
    }
  },
  beforeMount() {
    // Check and set value for group's RSVP completion.
    Group.rsvped()
  },
  methods: {
    goToNext() {
      this.$router.push('/')
    },   
  },
}
</script>